import Mixpanel from 'mixpanel-browser';
import Config from '@/config';
import { AppVersion, EventKey } from '@/types';
import { Generic, Nullable, User } from '@ygoargentina/sdk/api/api.types';
import { useUserStore } from '@/store/users';

type UserData = Pick<User, 'id' | 'name' | 'email' | 'lastName'>;

const getUserData = (user?: Nullable<User>) => {
  let innerUser = user;

  if (!user) {
    innerUser = useUserStore.getState().user;
  }

  const userProps: Partial<UserData> = {};
  const deviceData = {
    currentVersion: AppVersion,
    deviceMeta: {
      OS: 'web',
    },
  };

  if (innerUser) {
    userProps.id = innerUser.id;
    userProps.email = innerUser.email;
    userProps.name = innerUser.name;
    userProps.lastName = innerUser.lastName;
  }

  const extraProps = {
    env: Config.env,
    currentVersion: deviceData.currentVersion,
    OS: deviceData.deviceMeta.OS,
    appVersion: AppVersion,
  };

  return {
    userProps,
    extraProps,
  };
};

export const initAnalytics = (user?: User) => {
  const { userProps, extraProps } = getUserData(user);

  if (Config.useMixpanelAnalytics && Config.mixpanelToken) {
    const peopleConfig = {
      ...userProps,
      ...extraProps,
    };

    Mixpanel?.init(Config.mixpanelToken);

    if (peopleConfig.id) {
      Mixpanel?.identify(peopleConfig.id.toString());
    }

    Mixpanel?.register(peopleConfig);
  }
};

export const logEvent = (eventName: string, eventData?: Generic) => {
  mixpanelEvent(eventName, eventData);
};

export const logScreenView = async (
  screenName: string,
  restProps?: Generic
) => {
  mixpanelEvent(EventKey.ScreenView, { screenName, ...restProps });
};

export const mixpanelEvent = (eventName: string, props?: Generic) => {
  if (Config.useMixpanelAnalytics) {
    initAnalytics();
    Mixpanel?.track(eventName, props);
  }
};

export const clearMixpanel = () => {
  if (Config.useMixpanelAnalytics) {
    initAnalytics();
    Mixpanel?.reset();
  }
};
